import { all, fork } from 'redux-saga/effects';
import pageSaga from './page';
import tableSaga from './table';
import batchActionsSaga from './batchActions';
import scheduleSaga from './schedule';
import playgroundSaga from './playground';
import foldersSaga from './folders';
import journalsSaga from './journals';
import deviationsSaga from './deviations';
import productsSaga from './products';
import earningsSaga from './earnings';
import gallerySettingsSaga from './gallerySettings';
import originalsSaga from './originals';
import videoCreatorSaga from './videoCreator';

export default function* rootSaga() {
  yield all([
    fork(pageSaga),
    fork(tableSaga),
    fork(batchActionsSaga),
    fork(scheduleSaga),
    fork(playgroundSaga),
    fork(foldersSaga),
    fork(journalsSaga),
    fork(deviationsSaga),
    fork(productsSaga),
    fork(earningsSaga),
    fork(gallerySettingsSaga),
    fork(originalsSaga),
    fork(videoCreatorSaga),
  ]);
}
